/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		this.parent = this.closest('.product-recommendations--parent');

	}
	async fetchProducts() {
		await fetch(this.dataset.url)
			.then(response => response.text())
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('product-recommendations');

				if (recommendations && recommendations.innerHTML.trim().length) {
					this.innerHTML = recommendations.innerHTML;

					if ( this.parent ) {
						this.parent.classList.add('product-recommendations--full');

						if ( document.body.classList.contains('open-cart')) {
							this.parent.classList.add('active');
						}
					}

				}

				this.classList.add('product-recommendations--loaded');

			})
			.catch(e => {
				console.error(e);
			});
	}
	async connectedCallback() {
		await this.fetchProducts();
		this.sliderInit();
		window.addEventListener('resize', this.sliderInit.bind(this));
	}
	sliderInit() {
		if (window.innerWidth > 767) {
			if (typeof this.slider?.destroy == 'function') {
				this.slider.destroy();
				this.slider = {}
			}
			return;
		}
		else if (typeof this.slider?.destroy == 'function') {
			return;
		}
		const slider = this.querySelector('.collection');
		let args = {
			wrapAround: true,
			cellAlign: 'left',
			pageDots: true,
			contain: true,
			fade: false,
			autoPlay: false,
			prevNextButtons: false,
			cellSelector: '.columns',
			dragThreshold: 30,
			on: {}
		};
		this.slider = new Flickity(slider, args);
		
	}
}

customElements.define('product-recommendations', ProductRecommendations);
